export default __webpack_public_path__ + "static/media/os.a1cd3a23.svg";